import {
  FETCH_NARRATIVES_REQUEST,
  FETCH_NARRATIVES_SUCCESS,
  FETCH_NARRATIVES_FAILURE
} from '../../../Constants/actionTypes';

import { API_HOMEPAGE_CONTENT } from '../../../Constants/apiUrls';
import { fetchHomePageContent } from '../../../Constants/apiService'


export const fetchNarrativesRequest = () => ({
  type: FETCH_NARRATIVES_REQUEST
});

export const fetchNarrativesSuccess = (data) => ({
  type: FETCH_NARRATIVES_SUCCESS,
  payload: data
});

export const fetchNarrativesFailure = (error) => ({
  type: FETCH_NARRATIVES_FAILURE,
  payload: error
});

export const fetchNarratives = () => {
  return async (dispatch, getState) => {
    dispatch(fetchNarrativesRequest());

    const state = getState();
    const accessToken = state.auth.accessToken; // Assuming token is stored in auth state

    try {
      const data = await fetchHomePageContent(accessToken);
      dispatch(fetchNarrativesSuccess(data));
    } catch (error) {
      let errorMessage;
      if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
        errorMessage = 'Server is currently down. Please try again later.';
      } else {
        errorMessage = error.message;
      }
      dispatch(fetchNarrativesFailure(errorMessage));
    }
  };
};
